import React from "react";
import { Row, Col, Form, Input, Button, message } from 'antd';
import axios from "axios";
import { withTranslation } from 'react-i18next';

class BasicSettingsForm extends React.Component {
    state = {
        loading: true
    };

    componentDidMount() {
        let token = localStorage.getItem('token');
        axios.defaults.xsrfCookieName = 'csrftoken'
        axios.defaults.xsrfHeaderName = "X_CSRFTOKEN"
        axios.defaults.headers = {
            "Content-Type": "application/json",
            "Accept-Language": localStorage.getItem('language'),
            Authorization: `Token ${token}`,
        };
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.handleFormSubmit(
                    values,
                    e,
                    this.props.requestType,
                )
                console.log('Received values of form: ', values);
            }
        });
    };

    handleFormSubmit = (values) => {
        const postObj = {
            first_name: values.first_name,
            last_name: values.last_name,
            email: values.email,
        }

        // if (values.email) {
        //     axios.post(process.env.REACT_APP_AXIOS_URL + "/accounts/email/", values.email) // /accounts/email/ /api/profile/update/
        //         .then(res => {
        //             if (res.status === 200) {
        //                 message.success(this.props.t('profile.basic_settings.profile_updated', "Profile updated"));
        //                 // this.props.history.push(`/users`);
        //             } else {
        //                 message.error(this.props.t('profile.basic_settings.profile_update_failed', "Failed to update profile"));
        //             }
        //         });
        // }


        axios.patch(process.env.REACT_APP_AXIOS_URL + "/api/profile/update/", postObj) // /accounts/email/ /api/profile/update/
            .then(res => {
                if (res.status === 200) {
                    message.success(this.props.t('profile.basic_settings.profile_updated', "Profile updated"));
                    // this.props.history.push(`/users`);
                } else {
                    message.error(this.props.t('profile.basic_settings.profile_update_failed', "Failed to update profile"));
                }
            });
    };


    render() {
        const { getFieldDecorator } = this.props.form;
        const { requestType, t } = this.props;
        return (
            <Form layout="vertical" hideRequiredMark onSubmit={this.handleSubmit}>
                <Row>
                    <Col span={8}>
                        <Form.Item label={t('profile.basic_settings.first_name', "First name")} >
                            {
                                requestType === 'get' ?
                                    <span className="ant-form-text">{this.props.data.first_name}</span> :
                                    getFieldDecorator('first_name', {
                                        initialValue: this.props.data.first_name,
                                        rules: [{ required: true, message: t('profile.basic_settings.first_name_required', 'Please input the first name') }],
                                    })(<Input name="first_name" type="text" />)
                            }
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={8}>
                        <Form.Item label={t('profile.basic_settings.last_name', "Last name")}>
                            {
                                requestType === 'get' ?
                                    <span className="ant-form-text">{this.props.data.last_name}</span> :
                                    getFieldDecorator('last_name', {
                                        initialValue: this.props.data.last_name,
                                        rules: [{ required: true, message: t('profile.basic_settings.last_name_required', "Please input the last name") }],
                                    })(<Input name="last_name" type="text" />)
                            }
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={8}>
                        <Form.Item label={t('profile.basic_settings.email', "Email")}>
                            {
                                requestType === 'get' ?
                                    <span className="ant-form-text">{this.props.data.email}</span> :
                                    getFieldDecorator('email', {
                                        initialValue: this.props.data.email,
                                        rules: [{ required: true, message: t('profile.basic_settings.email_required', "Please input the email") }, { type: 'email', message: t('profile.basic_settings.email_invalid', "Please input valid email address") }],
                                    })(<Input name="email" type="text" />)
                            }
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        {t('general.update', "Update")}
                    </Button>
                </Form.Item>
            </Form>


        );
    }

}

const BasicSettings = Form.create()(withTranslation()(BasicSettingsForm));

export default BasicSettings;


// WEBPACK FOOTER //
// ./src/containers/Profile/BasicSettings.js